import get from 'lodash/get'

export const hasPermission = (user, requiredPermission) => {
  const permission = get(user, 'isSuper') || get(user, 'permissions', []).find(permission => permission.identifier === requiredPermission);
  if (!permission) {
    return false;
  }
  return true;
}
